import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './Components/HomePage';
import MainSourceCode from './Components/SourceCode/MainSourceCode';
import MainProjects from './Components/Projects/MainProjects';
import MainBlog from './Components/Blog/MainBlog';
import MainCheatsheets from './Components/Cheatsheets/MainCheatsheets';
import MainContactUs from './Components/ContactUs/MainContactUs';
import MainYTShorts from './Components/YTShorts/MainYTShorts';
import IframeDisplay from './Components/Projects/IframeDisplay';
import MainPortfolio from './Components/Portfolio/MainPortfolio';
import MainUIElemtns from './Components/UIElemtns/MainUIElemtns';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/source-code" element={<MainSourceCode />} />
        <Route path="/ui-elements" element={<MainUIElemtns />} />
        <Route path="/protfolio" element={<MainPortfolio />} />
        <Route path="/blog" element={<MainBlog />} />
        <Route path="/cheatsheets" element={<MainCheatsheets />} />
        <Route path="/contact-us" element={<MainContactUs />} />
        <Route path="/ytshorts" element={<MainYTShorts />} />
        <Route path="/iframe/:iframeLink" element={<IframeDisplay />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
